import React, { Component } from 'react';
import { SHOW_TOOLTIP_COLUMNS, createOverflowChecker } from 'helpers/dashboard';
import { UncontrolledTooltip } from 'reactstrap';
import { hour24ToMeridiem, MILITARY_FORMAT, formatExpirationDateTz } from 'helpers/datetime';
import { formatCurrency } from 'helpers/dashboard';
import { rateTypeNameFinder } from 'helpers/rateTypeName';
import moment from 'moment-timezone';
import classNames from 'classnames';
import JobActions from '../EventList/JobActions';
import { getStateStatus } from '../EventList/JobActions/JobActions';
import { getTimezone } from 'helpers/post';
import applied from 'all-applied.svg';
import { AthleticTrainerService } from 'services/v2';

class Job extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOverflowing: {},
      message: 'N/A',
    };
    this.columnRefs = {};
    SHOW_TOOLTIP_COLUMNS.jobsForShift.forEach(column => {
      this.columnRefs[column] = React.createRef();
    });
  }

  componentDidMount() {
    const checkOverflow = createOverflowChecker('jobsForShift', this.columnRefs, this.setState.bind(this));

    this.resizeObserver = new ResizeObserver(checkOverflow);
    SHOW_TOOLTIP_COLUMNS.jobsForShift.forEach(column => {
      this.resizeObserver.observe(this.columnRefs[column].current);
    });

    this.getEOMessage();
  }

  getEOMessage = () => {
    const { job } = this.props;
    const { user } = job;
    const athleticTrainerService = new AthleticTrainerService(this.props.session);
    athleticTrainerService
      .getATStatistics(user.id)
      .then(data => {
        this.setState({
          message: data.messageForEo,
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }

  displayNewDate = () => {
    const { shift } = this.props;
    const tz = getTimezone(shift.eventLocation);
    let job = this.props.job;
    if (job.jobModification) {
      job = {
        ...this.props.job.jobModification,
        startDate: moment.tz(this.props.job.jobModification.startTime, tz).format('MM/DD/YYYY'),
        endDate: moment.tz(this.props.job.jobModification.endTime, tz).format('MM/DD/YYYY'),
      };
    }

    const startDate = moment(job.startDate, MILITARY_FORMAT).format('MM/DD/YY');
    const endDate = moment(job.endDate, MILITARY_FORMAT).format('MM/DD/YY');

    if (moment(job.startDate, MILITARY_FORMAT).isSame(moment(job.endDate, MILITARY_FORMAT))) {
      return `New Date: ${startDate} `;
    }

    return `New Date: ${startDate} - ${endDate} `;
  };

  displayNewTime = () => {
    let job = this.props.job;
    const { shift } = this.props;
    const tz = getTimezone(shift.eventLocation);
    if (job.jobModification) {
      job = {
        ...this.props.job.jobModification,
        start: moment.tz(this.props.job.jobModification.startTime, tz).format('HH:mm'),
        end: moment.tz(this.props.job.jobModification.endTime, tz).format('HH:mm'),
      };
    }

    return `New Time: ${hour24ToMeridiem(job.start)} - ${hour24ToMeridiem(job.end)}`;
  };

  showUpdatedJob = type => {
    const { job, shift } = this.props;

    if (!['confirmed', 'checked_in', 'paid', 'eo_removed_at'].includes(job.currentState)) return false;

    const tz = getTimezone(shift.eventLocation);
    const shiftStartDate = moment.tz(shift.startTime, tz).format('MM/DD/YYYY');
    const shiftEndDate = moment.tz(shift.endTime, tz).format('MM/DD/YYYY');
    const shiftStart = moment.tz(shift.startTime, tz).format('HH:mm');
    const shiftEnd = moment.tz(shift.endTime, tz).format('HH:mm');

    const jobModification = job.jobModification;
    if (jobModification) {
      const jobModificationStartDate = moment.tz(jobModification.startTime, tz).format('MM/DD/YYYY');
      const jobModificationEndDate = moment.tz(jobModification.endTime, tz).format('MM/DD/YYYY');
      const jobModificationStart = moment.tz(jobModification.startTime, tz).format('HH:mm');
      const jobModificationEnd = moment.tz(jobModification.endTime, tz).format('HH:mm');

      if (type === 'time') return jobModificationStart !== shiftStart || jobModificationEnd !== shiftEnd;

      if (type === 'date')
        return jobModificationStartDate !== shiftStartDate || jobModificationEndDate !== shiftEndDate;

      return false;
    }

    if (type === 'time') return job.start !== shiftStart || job.end !== shiftEnd;

    if (type === 'date') return job.startDate !== shiftStartDate || job.endDate !== shiftEndDate;

    if (type === 'rate')
      return (
        Number(job.payRate) !== Number(shift.payRate) || Number(job.rateTypeId) !== Number(shift.rateTypeId)
      );

    return false;
  };

  displayAppExpires = () => {
    const { job } = this.props;
    const jobStartDate = moment(job.startTime);
    const appliedDate = moment(job.appliedDate);
    const diffBetweenStartAndApply = jobStartDate.diff(appliedDate, 'minutes');
    const SEVEN_DAYS_IN_MINUTES = 7 * 24 * 60;

    if (job.currentState !== 'pending') return false;

    return SEVEN_DAYS_IN_MINUTES <= diffBetweenStartAndApply;
  };

  render() {
    const { job, pendingApplicants, shift, from, allApplied, eventTitle } = this.props;
    const status = getStateStatus(job.currentState);
    const { user } = job;
    const tz = getTimezone(shift.eventLocation);
    const { message } = this.state;

    return (
      <div className="shift-job">
        <div className="col-3 add-padding">
          <div className="at-name" id={`atName-${job.id}`} ref={this.columnRefs['atName']}>
            {user.name}
            {this.state.isOverflowing.atName && (
              <UncontrolledTooltip target={`atName-${job.id}`}>{user.name}</UncontrolledTooltip>
            )}
          </div>
          {allApplied && (
            <React.Fragment key={`at-all-${job.id}`}>
              <img id={`at-all-${job.id}`} className="all-applied-icon" src={applied} alt="applied-icon" />
              <UncontrolledTooltip target={`at-all-${job.id}`}>
                {user.name} has applied to all shifts at this location.
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {message === 'YES' && (
            <React.Fragment key={`would-work-again-${job.id}`}>
              <i id={`would-work-again-${job.id}`} className="fa fa-star"></i>
              <UncontrolledTooltip target={`would-work-again-${job.id}`}>
                Would work with {user.name} again.
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </div>
        <div className={`col-2 ${status.statusColor} teal add-padding`}>{status.name}</div>
        <div className="col-5 shift-job-actions">
          <JobActions
            job={job}
            pendingApplicants={pendingApplicants}
            shift={shift}
            from={from}
            eventTitle={eventTitle}
            shifts={this.props.shifts}
          />
        </div>
        <div className="col-2 expire-text add-padding">
          <div className="new-updated-job">
            <p
              id={`date-${job.id}`}
              ref={this.columnRefs['date']}
              className={classNames({
                hidden: !this.showUpdatedJob('date'),
              })}
            >
              <React.Fragment>
                <span>/</span> {this.displayNewDate()}
                {this.state.isOverflowing.date && (
                  <UncontrolledTooltip target={`date-${job.id}`}>{this.displayNewDate()}</UncontrolledTooltip>
                )}
              </React.Fragment>
            </p>
            <p
              id={`time-${job.id}`}
              ref={this.columnRefs['time']}
              className={classNames({ hidden: !this.showUpdatedJob('time') })}
            >
              <span>/</span> {this.displayNewTime()}
              {this.state.isOverflowing.time && (
                <UncontrolledTooltip target={`time-${job.id}`}>{this.displayNewTime()}</UncontrolledTooltip>
              )}
            </p>
            <p
              id={`rate-${job.id}`}
              ref={this.columnRefs['rate']}
              className={classNames({ hidden: !this.showUpdatedJob('rate') })}
            >
              <span>/</span>{' '}
              {`New Rate: ${formatCurrency({
                currency: job.payRate,
                dollarSign: true,
              })}
              /
              ${rateTypeNameFinder(this.props.rateTypes, job.rateTypeId)} `}
              {this.state.isOverflowing.rate && (
                <UncontrolledTooltip target={`rate-${job.id}`}>
                  {`New Rate: ${formatCurrency({
                    currency: job.payRate,
                    dollarSign: true,
                  })}
                  /
                  ${rateTypeNameFinder(this.props.rateTypes, job.rateTypeId)} `}
                </UncontrolledTooltip>
              )}
            </p>
          </div>
          <p
            id={`expiration-date-${job.id}`}
            ref={this.columnRefs['expirationDate']}
            className={classNames('expiration-date')}
          >
            {this.displayAppExpires() && `/ App Expires: ${formatExpirationDateTz(job.expiresAt, tz)}`}
          </p>
          {this.displayAppExpires() && this.state.isOverflowing.expirationDate && (
            <UncontrolledTooltip target={`expiration-date-${job.id}`}>
              {`/ App Expires: ${formatExpirationDateTz(job.expiresAt, tz)}`}
            </UncontrolledTooltip>
          )}
        </div>
      </div>
    );
  }
}

export default Job;
